import { MainSlider } from "./main-slider";

export const LogoSlider = () =>
<div class="logo-container">
    <div class="logo-cell">
        <a href="/">
        <img
            class="img-responsive"
            src="https://www.artrenewal.org/secureimages/ContentSection/3/Images/859f2268-1cef-43d6-bec9-35d3c3a68038.jpg?w=951&h=303&mode=crop"
        />
        </a>
    </div>
    <div class="slider-cell">
        <MainSlider />
    </div>
</div>;